import { useSdk } from '~/sdk';


export const useProductFeatures = () => {
  const {locale} = useI18n();

  const productInfo = useAsyncData(`product-${locale.value}`, async () =>
    await useSdk().cms.getContent({
      globalSet: {
        handle: 'product',
        fragment: `
        ... on product_GlobalSet {
          title
          features {
            title
            ... on feature_Entry {
              heading: featureHeading
              body: featureBody {
                html
                rawHtml
                markdown
                plainText
              }
              images {
                title
                alt
                url
              }
              callToAction: featureCallToAction {
                title
                target
                url
                label
              }
            }
          }
        }
      `,
      },
    }),
  );


  return {

    features: computed(() => productInfo.data.value?.features ?? []),
  };
};
